var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:grid md:grid-cols-12"},[_c('div',{staticClass:"md:col-span-12"},[_c('carousel',{attrs:{"items":1,"dots":true,"nav":true,"center":true}},_vm._l((_vm.slides),function(slide){return _c('div',{key:slide.id},[_c('img',{staticClass:"py-4 lg:h-4/6 cust-border",attrs:{"src":slide.path}})])}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }